import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

export default function FloatingScrollButton(): React.JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      if (window.scrollY > 400) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisible, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-28 lg:bottom-20 right-4 lg:right-6 z-40 w-12 h-12 rounded-full flex items-center justify-center bg-heat-grad text-white shadow-heat-glow hover:shadow-heat-glow-lg hover:-translate-y-0.5 transition-all reveal"
      aria-label="Voltar ao topo"
    >
      <ChevronUp size={20} strokeWidth={2.5} />
    </button>
  );
}